let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("evpxF")).then(() => parcelRequire('4sBeG'));